import React from 'react';
import { Trans } from 'react-i18next';
import i18n from '../../i18n';
import { Link, Checkbox } from '@homeexchange/design';
import Analytics from '../../utils/analytics';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setTermsOfUseAccepted } from '../../actions/paymentForm';
function TermsOfUseCheckbox(_a) {
    var errorHandling = _a.errorHandling, termsOfUseAccepted = _a.termsOfUseAccepted, setTermsOfUseAccepted = _a.setTermsOfUseAccepted;
    var termOfUseTranslateLink = function () {
        return (React.createElement(Trans, { i18nKey: "subscription:payment_legalNotice_checkbox", components: [
                React.createElement(Link, { isSmall: true, key: window.location.host, href: i18n.t('url:link_terms-of-use') }),
                React.createElement(Link, { isSmall: true, key: window.location.host, href: i18n.t('url:link_code-of-conduct') }),
                React.createElement(Link, { isSmall: true, key: window.location.host, href: i18n.t('url:link_privacy-policy') })
            ], i18n: i18n }));
    };
    var handleTermsOfUseChange = function (isChecked) {
        if (setTermsOfUseAccepted) {
            setTermsOfUseAccepted(isChecked);
        }
        if (isChecked) {
            errorHandling.removeFormError('terms-of-use');
            Analytics.trackGTM('button', {
                event_data: {
                    action: 'click',
                    text: 'consent_checkbox_ticked',
                    area: 'payment_page'
                }
            });
        }
    };
    return (React.createElement(Checkbox, { name: "terms-of-use", className: !!errorHandling.formErrors['terms-of-use'] ? 'payment-error' : '', value: termsOfUseAccepted.toString(), checked: termsOfUseAccepted, label: termOfUseTranslateLink(), message: errorHandling.formErrors['terms-of-use'], hasError: !!errorHandling.formErrors['terms-of-use'], onChange: function (e) {
            var isChecked = e.target.checked;
            handleTermsOfUseChange(isChecked);
        } }));
}
var mapStateToProps = function (state) {
    var _a, _b;
    return ({
        termsOfUseAccepted: (_b = (_a = state.paymentForm) === null || _a === void 0 ? void 0 : _a.termsOfUseAccepted) !== null && _b !== void 0 ? _b : false
    });
};
var mapDispatchToProps = function (dispatch) { return ({
    setTermsOfUseAccepted: bindActionCreators(setTermsOfUseAccepted, dispatch)
}); };
export default connect(mapStateToProps, mapDispatchToProps)(TermsOfUseCheckbox);
